import { availabilityToAvailabilityEnum } from '../../../products/utils/availability.utils';
import { OfflineGridBuilder } from '../../builders/offlineGrid/OfflineGrid.builder';
import { offlineOrdersRepository } from '../../repositories/offlineOrders.repository';
import { useOfflineOrdersStore } from '../../stores/offlineOrders/offlineOrders.store';
import { CreateGridParams } from '../../stores/offlineOrders/types/offlineOrders.actions.types';
import { CreateOrUpdateOrderListOfflineAdapterParams } from './offlineRequestAdapterFunctions.types';

export const createOrUpdateOrderListOfflineAdapter = async ({
  orderId,
  items,
  kitId,
}: CreateOrUpdateOrderListOfflineAdapterParams) => {
  if (!items.every((item) => item.id)) {
    throw new Error('id is required for all items');
  }

  const { availability, deliveryWindowId, productColorId } = items[0];

  const typedDeliveryWindowId = deliveryWindowId ?? undefined;

  if (!availability || !productColorId) {
    console.error({
      availability,
      productColorId,
    });
    throw new Error('missing required fields');
  }

  const typedAvailability = availabilityToAvailabilityEnum(availability);

  const existentOrder = await offlineOrdersRepository.getById(orderId);

  const orderProductDoesNotExists = !existentOrder?.getOrderProduct({
    productColorId,
    availability: typedAvailability,
    deliveryWindowId: typedDeliveryWindowId,
  });

  if (orderProductDoesNotExists) {
    // @ts-ignore
    const gridItems: CreateGridParams[] = items.map((item) => ({
      id: item.id,
      quantity: item.quantity,
      skuId: item.skuId as string,
      kitId: kitId,
      productColorId: item.productColorId,
      deliveryWindowId: item.deliveryWindowId ?? undefined,
      availability: item.availability,
    }));

    await useOfflineOrdersStore.getState().addProductBasedOnGrid({ orderId, gridItems, kitId });
  }

  const order = await useOfflineOrdersStore.getState().changeProductGrid({
    orderId,
    gridItemsIdsAndQuantity: items.map((item) => ({
      id: item.id!,
      quantity: item.quantity!,
    })),
    orderProductIds: {
      productColorId,
      availability: typedAvailability,
      deliveryWindowId: typedDeliveryWindowId,
    },
  });

  const orderProduct = order.getOrderProduct({
    productColorId,
    availability: typedAvailability,
    deliveryWindowId: typedDeliveryWindowId,
  })!;

  const offlineGridBuilder = new OfflineGridBuilder({
    offlineOrder: order,
    availability: typedAvailability,
    priceTableId: order.priceTable.id,
    deliveryWindowId: typedDeliveryWindowId,
    productColorId: orderProduct?.productColor.id,
  });

  const productDto = await offlineGridBuilder.build();

  return productDto;
};
